import React from 'react';
import {
  TempoPatientRowDTO,
} from 'dtos';
import {
  DateRange,
} from 'types/dateRange';
import Button from 'pages/Dashboard/components/Button';
import Dialog from 'pages/Dashboard/components/Dialog';
import TempoPatientDetailContent from 'pages/Dashboard/pages/Dashboard/Tempo/Details/TempoPatientDetailContent';

type Props = {
  patientData: TempoPatientRowDTO;
  dateRange: DateRange;
  onClose: () => void;
};

export default function TempoPatientDetailDialog({
  patientData,
  dateRange,
  onClose,
}: Props) {
  const patientId = patientData.patient?.patientId ?? 0;

  return (
    <Dialog
      open
      onClose={onClose}
      title="Tempo Patient Details"
      maxWidth={false}
      classes={{
        root: '!h-full min-h-0 !w-full min-w-[min(900px,calc(100vw-32px))] overflow-hidden !p-0 !space-y-0',
        dialog: 'hidden-backdrop populate-iframe-modal !m-0 settings-form-dialog !w-[min(900px,calc(100vw-32px))] min-w-[min(900px,calc(100vw-32px))] !max-w-none',
        bodyRoot: '!m-0 !h-[min(715px,calc(100dvh-48px))] !w-[min(900px,calc(100vw-32px))] min-w-[min(900px,calc(100vw-32px))] !max-w-none !max-h-[min(800px,calc(100dvh-48px))] !overflow-hidden !rounded-xl',
        container: '!items-center !justify-center p-3',
        title: 'border-0 p-4 shrink-0 border-b border-gray-200',
      }}
    >
      <div className="flex min-h-0 flex-auto flex-col overflow-hidden">
        <TempoPatientDetailContent
          patientId={patientId}
          dateRange={dateRange}
          onNavigateAway={onClose}
        />
        <div className="flex shrink-0 justify-end border-t border-gray-200 bg-white px-5 py-4">
          <Button type="button" variant="outlined" onClick={onClose}>
            Close
          </Button>
        </div>
      </div>
    </Dialog>
  );
}
